import type { FC } from 'react';
import { Progress } from '@components/ui/progress';
import type { RenewalSummaryJobView } from '@responses/renewal-summary';

import { STAGE_LABEL } from '../constants';
import { useEstimatedProgress } from '../hooks/useEstimatedProgress';

import { SummaryHero } from './SummaryHero';

interface GeneratingStateProps {
  job: RenewalSummaryJobView;
}

/** While a job is in flight: what is happening, and an estimated progress bar. */
export const GeneratingState: FC<GeneratingStateProps> = ({ job }) => {
  const progress = useEstimatedProgress(job);

  return (
    <div data-testid="renewal-summary-generating">
      <SummaryHero title="Writing your summary">
        This usually takes a minute or two. You can close this panel and keep working. We&apos;ll let you know when
        it&apos;s ready.
      </SummaryHero>
      <div className="px-6 pb-6">
        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-600" data-testid="renewal-summary-stage">
            {STAGE_LABEL[job.stage ?? 'COMPARING']}
          </span>
          <span className="font-semibold text-gray-900 tabular-nums">{progress}%</span>
        </div>
        <Progress className="mt-1.5" value={progress} aria-label="Summary progress" />
      </div>
    </div>
  );
};
